var map = {
	"./oldtecho.jpg": 9202,
	"./pared.jpg": 2909,
	"./piso.jpg": 6931,
	"./regleta.jpg": 9660,
	"./techo.jpg": 4722,
	"./todas.jpg": 5144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;